import { Form, FormProps } from "@/components/form";
import { z } from "zod/v4";

export const cajaFormSchema = z.object({
    nombre: z.string().nonempty("Este campo es requerido")
})

export default function CajaForm({
    form,
    ...props
}: FormProps<z.infer<typeof cajaFormSchema>>) {
    return <Form form={form} gap={3} {...props}>
        <Form.TextField name="nombre" label="Nombre" />
        <Form.SubmitButton>Guardar</Form.SubmitButton>
    </Form>
}